// User service for API calls
import { User, UserApiResponse } from '../types/user';
import { fetchWithErrorHandling } from './apiUtils';

function transformUserResponse(apiUser: UserApiResponse): User {
    return {
        id: apiUser.id,
        email: apiUser.email,
        alternateUsername: apiUser.alternateUsername,
        fastpass: apiUser.fastpass ?? undefined,
        fullName: apiUser.fullName,
        phone: apiUser.phone,
        fax: apiUser.fax,
        mobile: apiUser.mobile,
        accountingCode: apiUser.accountingCode,
        departments: apiUser.departments,
        switched: apiUser.switched,
        apiToken: apiUser.api_token,
        client: apiUser.client,
        active: apiUser.active,
        disable: apiUser.disable,
        admin: apiUser.admin,
        bulkOrder: apiUser.bulk_order,
        locationId: apiUser.location_id,
        privOrder: apiUser.priv_order,
        privPayAccount: apiUser.priv_pay_account,
        privPayCard: apiUser.priv_pay_card,
        rightsAdmin: apiUser.rights_admin,
        rightsReports: apiUser.rights_reports,
        restricted: apiUser.restricted,
        shippingAllowLocalPickup: apiUser.shipping_allow_local_pickup,
        shippingAllowExternal: apiUser.shipping_allow_external,
        shippingAllowOneDay: apiUser.shipping_allow_one_day,
        shippingAllowTwoDay: apiUser.shipping_allow_two_day,
        shippingAllowGround: apiUser.shipping_allow_ground,
        shippingAllowEconomy: apiUser.shipping_allow_economy,
        shippingAllowWeekendDelivery: apiUser.shipping_allow_weekend_delivery,
        clientId: apiUser.client_id,
        privAll: apiUser.priv_all,
        privEmail: apiUser.priv_email,
        privUser: apiUser.priv_user,
        rightsAccount: apiUser.rights_account,
        rightsHelp: apiUser.rights_help,
        rightsOrders: apiUser.rights_orders,
        rightsQueue: apiUser.rights_queue,
        rightsWare: apiUser.rights_ware,
        globalAdmin: apiUser.global_admin,
        distributorAdmin: apiUser.distributor_admin,
        clientAdmin: apiUser.client_admin,
    };
}

export class UserService {
    static async getCurrentUser(): Promise<User> {
        const endpoint = `/api/v2/users/me`;
        const apiResponse = await fetchWithErrorHandling<UserApiResponse>(endpoint);
        return transformUserResponse(apiResponse);
    }
}
